import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/AccountingTypes';
import { form } from '../Form/accountingTypes';
import { form as searchForm } from '../Form/Search/accountingTypes';

import { accountingTypes as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "accountingType",
    pageTitle: strings.common.homepage.accountingTypes,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_ACCOUNTING_ACCOUNT'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.title) {
        result["title"] = search.title;
      }
      if(search.collectiveClientNumber) {
        result["collective_client_number"] = search.collectiveClientNumber;
      }
      return result;
    },

    availableItemDisplay:['tab'],
    itemDisplay: {
      tab: {
        headers: [
          {
            label: strings.accountingType.index.tab.headers.title,
            value: "title"
          },
          {
            label: strings.accountingType.index.tab.headers.collectiveClientNumber,
            value: "collective_client_number"
          },
        ]
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.accountingTypes,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "title",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.accountingType.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_ACCOUNTING_ACCOUNT'],
        editable: ['ROLE_ACCOUNTING_ACCOUNT']
      }
    }
  },
  new: {
    pageTitle: strings.accountingType.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (accountingType) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
